import { API_V6_URL, API_BASE_URL, REGISTER } from "services/apiURl";
import api from "../utils/request";

export const registerAccountAPI = async (payload) => {
  try {
    const response = await api.post(`${REGISTER}`, payload);
    return response;
  } catch (error) {
    console.error("Register POST API error", error);
    return error;
  }
};

export const accessCardGetOTPAPI = async (payload) => {
  const response = await api.post(
    `${API_V6_URL}/register/0/access_card_get_otp/`,
    payload
  );

  return response;
};

export const loginAccessCardOTPAPI = async (payload) => {
  const response = await api.post(
    `${API_V6_URL}/register/0/otp_verify_and_login_access_card/`,
    {
      email: payload.email,
      otp: payload.otp,
      albumID: payload.albumID,
      accessUID: payload.accessUID
    }
  );
  return response;
};

export const postKidsName = async (payload) => {
  const orgId = payload.orgId;
  try {
    const postResponse = api.post(
      // `${API_V6_URL}/orgs/${orgId}/event-orders/0/add_kids_name/`,
      `${API_V6_URL}/orgs/${orgId}/event-orders/0/update_event_order_meta/`,
      payload
    );

    // Check if the response is undefined or null
    if (!postResponse) {
      console.error("Post kids name no server response");
      // response = {};
      // throw new Error("No response from server");
    }
    return postResponse;
  } catch (error) {
    console.error("Error in post kids name", error);
    return error;
  }
};

export const postNewAddressAPI = async (payload) => {
  try {
    const response = await api.post(`${API_V6_URL}/shipping/`, payload);
    return response;
  } catch (error) {
    console.error("Error adding new address:", error);
    return error;
  }
};

export const postPONewAddressAPI = async (payload) => {
  try {
    const response = await api.post(`${API_V6_URL}/po-address/`, payload);
    return response;
  } catch (error) {
    console.error("Error adding new address:", error);
    return error;
  }
};

export const generateNewPOForCustomerAPI = async () => {
  try {
    const response = await api.get(
      `${API_BASE_URL}/api/v6/parent/cart/init-po/`
    );
    return response;
  } catch (error) {
    console.error("Error creating PO for customer:", error);
    return error;
  }
};

export const getOTPForPasswordReset = async () => {
  try {
    const resp = await api.post(
      `${API_BASE_URL}/api/v6/register/0/generate_new_otp/`
    );
    return resp;
  } catch (error) {
    console.error("Error creating PO for customer:", error);
    return error;
  }
};

export const verifyOTPAPI = async (payload) => {
  try {
    const resp = await api.post(
      `${API_BASE_URL}/api/v6/register/0/verify_otp/`,
      payload
    );
    return resp;
  } catch (error) {
    console.error("Error for OTP Verify:", error);
    return error;
  }
};

export const resetUserPassword = async (payload) => {
  try {
    const resp = await api.post(
      `${API_BASE_URL}/api/v6/register/0/reset_password_with_otp/`,
      payload
    );
    return resp;
  } catch (error) {
    console.error("Error resetting user password:", error);
    return error;
  }
};

export const payByCashAPI = async (payload) => {
  try {
    const resp = await api.get(
      `${API_BASE_URL}/api/v6/payments/process_cash_payment_pixcart/`,
      payload
    );

    return resp;
  } catch (error) {
    console.error("Error in cash payment:", error);
    return error;
  }
};

export const payBySchoolCashAPI = async () => {
  try {
    const resp = await api.get(
      `${API_BASE_URL}/api/v6/payments/process_cash_payment_pixcart/`,
      {
        params: {
          is_school_mode: true
        }
      }
    );

    return resp;
  } catch (error) {
    console.error("Error in school cash payment:", error);
    return error;
  }
};
